/** Valor ausente nas informações da embarcação. */
export const SEM_VALOR = "—";
